// [NEW IMPLEMENTATION] Report Filters Card Component
// # Command Line: Refactored filter logic to support hybrid ID/Name search and URL state persistence.
// Logic:
// 1. A reusable, collapsible card wrapper for report filter sections.
// 2. Maintains internal toggle state (isOpen) to manage screen real estate.
// 3. Supports dynamic titles and optional header actions.
import { useState, type ReactNode } from "react";

type ReportFiltersCardProps = {
  children: ReactNode;
  title?: string;
  extra?: ReactNode;
  defaultOpen?: boolean;
  className?: string;
};

const ReportFiltersCard = ({
  children,
  title = "Filters",
  extra,
  defaultOpen = true,
  className = "",
}: ReportFiltersCardProps) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <section className={`enablement-filters filters-dropdown-card ${isOpen ? "is-open" : ""} ${className}`.trim()}>
      <div className="filters-dropdown-header">
        <span className="filters-section-title">{title}</span>
        <button
          type="button"
          className="filters-dropdown-toggle"
          onClick={() => setIsOpen((prev) => !prev)}
          aria-expanded={isOpen}
          aria-label={isOpen ? "Collapse filters" : "Expand filters"}
          // title={isOpen ? "Collapse" : "Expand"}
        >
          <span className="filters-dropdown-icon">
            {isOpen ? (
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="18 15 12 9 6 15"></polyline>
              </svg>
            ) : (
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="6 9 12 15 18 9"></polyline>
              </svg>
            )}
          </span>
        </button>
      </div>
      {isOpen ? <div className="filters-dropdown-body">{children}</div> : null}
    </section>
  );
};

export default ReportFiltersCard;
